// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import type Enums from '../Enums';

export class ImportedDiscount {
  readonly id: string;
  readonly name: string;
  readonly externalID: string;
  readonly integrationID: string;
  readonly amount: string;
  readonly amountType: string;
  readonly stackable: boolean;
  readonly validFrom: DateTime | null;
  readonly validTo: DateTime | null;
  readonly pricingTierRefs: string[];
  readonly deliveryType: Enums.ProductDeliveryType | null;
  readonly companyIDs: string[];
  readonly productIDs: string[];
  readonly isArchived: boolean;
  readonly createdAt: DateTime;
  readonly updatedAt: DateTime;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.externalID = data.externalID === undefined ? '' : data.externalID;
    this.integrationID = data.integrationID === undefined ? NIL_UUID : data.integrationID;
    this.amount = data.amount === undefined ? '0' : data.amount;
    this.amountType = data.amountType === undefined ? '' : data.amountType;
    this.stackable = data.stackable === undefined ? false : data.stackable;
    this.validFrom = DateHelpers.ParseServerNullableDate(data.validFrom);
    this.validTo = DateHelpers.ParseServerNullableDate(data.validTo);
    this.pricingTierRefs = data.pricingTierRefs ?? [];
    this.deliveryType = data.deliveryType === undefined ? null : data.deliveryType;
    this.companyIDs = (data.companyIDs ?? []).map((companyIDs: any) =>
      companyIDs === undefined ? NIL_UUID : companyIDs,
    );
    this.productIDs = (data.productIDs ?? []).map((productIDs: any) =>
      productIDs === undefined ? NIL_UUID : productIDs,
    );
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
    this.createdAt = DateHelpers.ParseServerDateTime(data.createdAt);
    this.updatedAt = DateHelpers.ParseServerDateTime(data.updatedAt);
  }

  static zero(): ImportedDiscount {
    const zeroValues: ExcludeMethodsDeep<ImportedDiscount> = {
      id: NIL_UUID,
      name: '',
      externalID: '',
      integrationID: NIL_UUID,
      amount: '0',
      amountType: '',
      stackable: false,
      validFrom: null,
      validTo: null,
      pricingTierRefs: [],
      deliveryType: null,
      companyIDs: [],
      productIDs: [],
      isArchived: false,
      createdAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
      updatedAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
    };
    return new ImportedDiscount(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ImportedDiscountWireFormat = {
  id: string;
  name: string;
  externalID: string;
  integrationID: string;
  amount: string;
  amountType: string;
  stackable: boolean;
  validFrom: string | null;
  validTo: string | null;
  pricingTierRefs: string[];
  deliveryType: string | null;
  companyIDs: string[];
  productIDs: string[];
  isArchived: boolean;
  createdAt: string;
  updatedAt: string;
};

type NewImportedDiscountProps = PartialDeep<ImportedDiscount, { recurseIntoArrays: true }>;
export const NewImportedDiscount: (props: NewImportedDiscountProps) => ImportedDiscount = (props) =>
  new ImportedDiscount(props);

type NewImportedDiscountFromWireFormatProps = PartialDeep<
  ImportedDiscountWireFormat,
  { recurseIntoArrays: true }
>;
export const NewImportedDiscountFromWireFormat: (
  props: NewImportedDiscountFromWireFormatProps,
) => ImportedDiscount = (props) => new ImportedDiscount(props);
